<div
  class="form-group row align-items-center"
  *ngIf="ValidationList.length > 0"
>
  <div class="validation-summary">
    <p class="validation-message" *ngIf="ValidationLabel == ''">
      Following textboxes have invalid information:
    </p>
    <p
      class="validation-message"
      *ngIf="ValidationLabel !== ''"
      [innerHTML]="ValidationLabel"
    ></p>
    <ul class="validation-error-list">
      <li class="validation-error" *ngFor="let fixString of ValidationList">
        {{ fixString }}
      </li>
    </ul>
  </div>
  <br />
</div>
